export function KyivstarSvg() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
            <path d="M9.88501 1.5V5.79397V1.5Z" fill="black" />
            <path d="M9.88501 1.5V5.79397" stroke="#00A0FF" strokeWidth="2.42308" strokeLinecap="round" />
            <path d="M17.7712 7.22949L13.6874 8.5564L17.7712 7.22949Z" fill="black" />
            <path d="M17.7712 7.22949L13.6874 8.5564" stroke="#00A0FF" strokeWidth="2.42308" strokeLinecap="round" />
            <path d="M14.7598 16.5L12.2358 13.0261L14.7598 16.5Z" fill="black" />
            <path d="M14.7598 16.5L12.2358 13.0261" stroke="#00A0FF" strokeWidth="2.42308" strokeLinecap="round" />
            <path d="M5.01172 16.5L7.53565 13.0261L5.01172 16.5Z" fill="black" />
            <path d="M5.01172 16.5L7.53565 13.0261" stroke="#00A0FF" strokeWidth="2.42308" strokeLinecap="round" />
            <path d="M2 7.22949L6.08381 8.5564L2 7.22949Z" fill="black" />
            <path d="M2 7.22949L6.08381 8.5564" stroke="#00A0FF" strokeWidth="2.42308" strokeLinecap="round" />
        </svg>
    )
}